"use strict";

angular.module("customer")
.service("NotificationService", function($resource, appConfig) {
    var notificationResource = $resource(appConfig.API_SERVER + "/auth/customer/communication/notifications/:id/", {id: "@id"}, {
        query: {method: "GET", isArray: false},
        update: {method: "PUT"}
    });

    this.query = function(unread, page) {
        var params = {
            unread: unread,
            page: page
        };
        return notificationResource.query(params).$promise;
    };

    this.markAsRead = function(notification) {
        var notificationInstance = new notificationResource({id: notification.id});
        notificationInstance.unread = false;
        return notificationInstance.$update();
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/notification/notification.service.js
// module id = 837
// module chunks = 0